import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export function FinanceSourceDataHint({ domain }: { domain: 'application' | 'route' }) {
  const label =
    domain === 'application'
      ? 'Источник данных: заявка (клиентский финансовый домен)'
      : 'Источник данных: маршрут (финансы перевозчика)';
  return (
    <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 8 }}>
      {label}
    </Text>
  );
}
